import scStyled, {
  CSSObject,
  createGlobalStyle as scCreateGlobalStyle,
  keyframes as scKeyframes,
  css,
} from "styled-components"
import { Theme } from "../theme"

export interface StyleProps {
  theme: Theme
}

export type WithCSS = {
  css?: CSSFn
}
export type StylePropsWithCSS = StyleProps & WithCSS

export const styled = scStyled
export type CSS = CSSObject
export type CSSFn = (props: StyleProps) => CSS
export const createGlobalStyle = scCreateGlobalStyle
export const keyframes = scKeyframes
export const cssHelper = css
export const callCSSFn = (allProps: StylePropsWithCSS) => {
  const { css, ...props } = allProps // eslint-disable-line no-shadow, @typescript-eslint/no-shadow
  if (!css) return undefined
  return css(props)
}
